import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { combinedSettingsSelector, getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type ProgressBarProps } from "./component";
import { makeBarContainerStyleSelector, makeBarInnerStyleSelector, makeBarStyleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const barContainerStyleSelector = makeBarContainerStyleSelector();
  const barInnerStyleSelector = makeBarInnerStyleSelector();
  const barStyleSelector = makeBarStyleSelector();

  const titlePositionSelector = getSettingValueSelector(TargetSelector.Entity, "titlePosition");
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    { name: "delay", converter: (value: string) => (value.endsWith("ms") ? value : `${value}ms`), prop: "delay" },
    { name: "percent", converter: (x) => parseInt(x), prop: "percent" },
    "title"
  ]);

  return (state: AppState, props: RootContainerProps): ProgressBarProps => {
    const { delay, percent, title } = settingsSelector(state, props);
    return {
      ...props,
      barContainerStyle: barContainerStyleSelector(state, props),
      barInnerStyle: barInnerStyleSelector(state, props),
      barStyle: barStyleSelector(state, props),
      delay,
      percent,
      title,
      titlePosition: titlePositionSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
